import React from 'react';

export default {
    Eng: {
        formTitle: "Lodgement List", 

        // Form fields
        part_a_particulars: "Lodgement List", 

        // Form - Part1
        SolicitorCode: "Solicitor Code",
        NameOfLodgingParty: "Name of lodging party",
        Date: "Date",
        HaveCheque: "Use cheque(s) for payment",
        field_HaveCheque_list:[
            {id: "HaveCheque", value: "Yes", text: "Yes"},
            {id: "HaveCheque", value: "No", text: "No", },
        ],
        NoOfCheques: "No. of Cheque(s)",
        TotalAmount: "Total amount",

        RecordListTitle: "List of Instruments",
        OrderOfLodgement: "Order of Lodgement",
        NatureOfInstrument: "Nature of Instrument",
        PRN: "PRN No. / Address (including Block, Floor & Flat) / Lot No. (including Block, Floor & Flat) of the premises affected)",

        Warn_IdenticalInstrument: ()=><>The following instruments have identical descriptions.<br/> Please check before going to the next step.</>,
        Warn_OrderOfLodgement: "Order of Lodgement #{0} and #{1}",

        notes1: ()=> [<>
        <div>
            For application sent in by post, please ensure that sufficient postage is paid to avoid unsuccessful delivery of application. Any underpaid mails will be handled by the Hongkong Post and the Land Registry will not settle the relevant surcharge payments for underpaid mails.
        </div>
        </>],

        acknowledgement_offline_para: ()=>(
            <>
                    <p>Your form has been successfully printed.</p>
                    <p>To complete your application, please deliver the printed form to the Land Registry by post/courier service or in person.</p>
            </>
        ),
    }
};